
import { CommentSerializer } from "../../../models/serializers/CommentSerializer.ts";
import { httpRequest } from "../../http";
import { Comment } from "../../../models/comment.model.ts";

export class CommandFetchComment {
    async run(todoId:number) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/todos/${todoId}/comments/`;
        try {
            const response = await httpRequest<any>(url, { method: "GET" });
            return this.deserialize(response.comments);
            
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any) : Comment []{
        const serializer = new CommentSerializer();
        return serializer.deserializeList(data);
    }
}

